import {
  useSendSmsLoginLink,
  type SendSmsLoginRedirectLinkData,
} from '~/@mid_onboarding/sms-login/useSendSmsLoginLink'
import { IdentityVerificationSocialInAppWebViewDialog } from '~/@mid_onboarding/sms-login/IdentityVerificationSocialInAppWebViewDialog'

type Props = {
  children(
    handleSubmitForm: (props: SendSmsLoginRedirectLinkData) => void,
    isPending: boolean
  ): React.ReactNode
}

function PhoneVerificationSocialInAppWebView({ children }: Props) {
  const {
    mutate,
    isPending,
    twoFaCodeExpiresAt,
    isDialogOpen,
    setIsDialogOpen,
  } = useSendSmsLoginLink()

  return (
    <>
      {children(mutate, isPending)}

      {isDialogOpen && (
        <IdentityVerificationSocialInAppWebViewDialog
          title="Overenie telefónneho čísla"
          description="Pre overenie telefónneho čísla kliknite na odkaz v SMS od Invest in Slovakia, ktorú sme zaslali na vaše telefonné číslo."
          onClose={() => setIsDialogOpen(false)}
          expiresAt={twoFaCodeExpiresAt}
          handleResendSms={mutate}
          isSendingSms={isPending}
        />
      )}
    </>
  )
}

export { PhoneVerificationSocialInAppWebView }
